// Design-system shell · public exports.
export { AppShell } from "./AppShell";
export { TopBar } from "./TopBar";
export { SideRail } from "./SideRail";
export { RecordHeader, ContextualTabs } from "./RecordHeader";
// R1b-α Step 1 Slice C — Dead-code deletion.
// The old `./PortalSwitcherLauncher` (stub with no consumers) was removed
// from this folder. The live implementation is exported from
// `../nav/PortalSwitcherLauncher`.
export { PortalSwitcherLauncher } from "../nav/PortalSwitcherLauncher";

